import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../features/auth/AuthContext.jsx";

export default function Nav() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <nav style={{ borderBottom: "1px solid var(--app-border)" }}>
      <div className="container row" style={{ height: 64 }}>
        <Link to="/" style={{ textDecoration: "none", fontWeight: 800, letterSpacing: -0.5 }}>
          einvite<span style={{ color: "var(--app-accent)" }}>.to</span>
        </Link>
        <div className="spacer" />
        {user ? (
          <>
            <Link to="/app" className="btn-ghost btn">My events</Link>
            <button
              className="btn-ghost btn"
              onClick={async () => { await signOut(); navigate("/"); }}
            >
              Sign out
            </button>
          </>
        ) : (
          <Link to="/app" className="btn-ghost btn">Sign in</Link>
        )}
      </div>
    </nav>
  );
}
